namespace Areas.Account.Milestones{
    "use strict";
   
    let currentMilestoneRow: any;
    let selectedAccount: any;

    export function onNewMilestoneRow(e: any) {
        currentMilestoneRow = e.data;
        currentMilestoneRow.accountId = e.component.option("AccountId");
        currentMilestoneRow.projectCCNumber = e.component.option("ProjectCCNumber");
        currentMilestoneRow.accountName = e.component.option("AccountName");
        currentMilestoneRow.projectId = e.component.option("ProjectId");
        selectedAccount = e.component.option("ProjectCCNumber");
    }

    export function onSelectionChanged(e: any) {
        var selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            selectedAccount = selectedRows[0].projectCCNumber;
        }
    }

    export function onEditingStart(e: any) {
        currentMilestoneRow = e.data;
        selectedAccount = e.data.projectCCNumber;
    }

    export function selectAccount() {
        const grid: any = $("#MilestoneGrid").dxDataGrid("instance");
        const parameters = { projectId: grid.option("ProjectId") };

        const projectLookupDialog =
            new Areas.Dialogs.Project.ProjectLookupDialog(dialogAccountClosing, parameters);
    }

    function dialogAccountClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#MilestoneGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateAccountGridRow(dataGrid, rowIndex, data);
    }

    function getItemRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentMilestoneRow === undefined || currentMilestoneRow === null) {
            return rowIndex;
        } else if (currentMilestoneRow.accountMilestoneId) {
            rowIndex = dataGrid.getRowIndexByKey(currentMilestoneRow.accountMilestoneId);
        }

        return rowIndex;
    }

    function updateAccountGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "accountId", data.accountId);
        dataGrid.cellValue(rowIndex, "projectCCNumber", data.projectCCNumber);
        dataGrid.cellValue(rowIndex, "accountName", data.accountName);

        currentMilestoneRow.accountId = data.accountId;
        currentMilestoneRow.projectCCNumber = data.projectCCNumber;
        currentMilestoneRow.accountName = data.accountName;

        selectedAccount = data.projectCCNumber;

        dataGrid.repaintRows([rowIndex]);
    }

    export function onRowInserted(e: any) {
        selectedAccount = e.component.option("ProjectCCNumber");
        currentMilestoneRow = null;
    }

    export function editAccountTemplate(cellElement, cellInfo) {
        let projectCCNumber = !selectedAccount ? "Select..." : selectedAccount;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${projectCCNumber}</div><div class="dx-lookup-arrow" id="account-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectAccount);
        cellElement.append(html);
    }

}